import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ChevronDown, ChevronRight, User, Tag, CreditCard, ExternalLink } from "react-feather";
import { paths } from "../../../../routes/paths";
import { useCollectionsRecords } from "../../useCollectionsRecords";
import { money } from "../../dashboardHelpers";
import { summarizeByEmployee, summarizeByServiceType, summarizeByPaymentType } from "../../collectionsSummaryAggregator";
import MiniSummaryTable from "./MiniSummaryTable";

// Collapsed by default, matching Flutter's _CollapsibleBranchStrip exactly -
// plain bordered card, no alternating branch-row colors (an earlier, now-
// superseded memory description mentioned "zigzag" strips; the real Flutter
// code doesn't do that). Records are lazy-fetched on first expand only.
const CollapsibleBranchStrip = ({ branchId, branchLabel, totalAmount, dateFrom, dateTo }) => {
  const [expanded, setExpanded] = useState(false);
  const { rows, isLoading } = useCollectionsRecords(
    { branchId, dateFrom, dateTo },
    { skip: !expanded }
  );

  return (
    <div className="collections-branch-strip">
      <div className="collections-branch-strip-header" onClick={() => setExpanded((v) => !v)}>
        <span className="collections-branch-strip-icon">
          <MapPin size={13} />
        </span>
        <span className="flex-grow-1 fw-semibold small">{branchLabel}</span>
        <span className="fw-semibold small me-2">{money(totalAmount)}</span>
        {/* Separate from the expand/collapse: the header toggles the breakdown,
            this opens the actual records. stopPropagation so clicking the link
            doesn't also toggle the strip underneath it. */}
        <Link
          to={paths.collectionsFiltered({ branchId, dateFrom, dateTo })}
          className="me-2 text-muted"
          title={`See ${branchLabel} collection records`}
          onClick={(e) => e.stopPropagation()}
        >
          <ExternalLink size={13} />
        </Link>
        {expanded ? <ChevronDown size={15} /> : <ChevronRight size={15} />}
      </div>
      {expanded && (
        <div className="collections-branch-strip-body">
          {isLoading ? (
            <div className="text-muted small">Loading...</div>
          ) : (
            <>
              <MiniSummaryTable title="Employee Wise Collection" icon={<User size={12} />} rows={summarizeByEmployee(rows)} />
              <MiniSummaryTable title="Type Wise Collection" icon={<Tag size={12} />} rows={summarizeByServiceType(rows)} />
              <MiniSummaryTable title="Payment Type Wise Collection" icon={<CreditCard size={12} />} rows={summarizeByPaymentType(rows)} />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CollapsibleBranchStrip;
